import { Store } from 'pullstate';
import { Position, PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

// this has to be here instead of in utils to prevent circular dependency
export const getZeroMatrix = (puzzleSize: number) =>
  Array.from({ length: puzzleSize }, () => Array(puzzleSize).fill(0));

export type PathwordStoreType = PuzzleStoreBase & {
  // The path is a matrix of numbers representing the sequence 1-16.
  // The jsx grabs the [row][col]th element of the matrix to get
  // the index number of what letter from the clustring to show in that cell.
  // (Although of course the cluestring is 0-indexed, as a string, whereas
  // the path is 1-indexed. So we subtract 1 to accomodate when we index the cluestring.)
  // EDIT: can we just not do that, and have it be 0-15 instead? why did we do that?
  path: number[][];
  // kv store of path index to the class names for the lines for that cell in the path
  lines: {[key: number]: string | null};
  pathLength: number;
  pathHead: Position | null;
  highlights: number[][];
  // Used to propagate an animation out from the final square over the course of a second
  successAnimationGrid: number[][];
  puzzleSize: number;
  // 1s are consonants and 0s are vowels;
  vowelMatrix: number[][];
  cluetext: string[];
  solutionPath: number[][];
  solutionLines: {[key: number]: string | null};
  almostThereIsOpen: boolean;
  // Array of indices in cluetext that are hint letters (revealed to player)
  hintLetters: number[];
  // Indices into hintLetters array indicating which hints are enabled (e.g. [0,2] shows 1st and 3rd hints)
  enabledHints: number[];
  // Number of hints enabled at the start (to calculate available lifeline hints)
  initialEnabledHints: number;
  // Map of grid positions to hint letter indices: { "row_col": hintIndex }
  hintPositions: {[key: string]: number};
  // Number of times the "Get hint" lifeline has been used
  hintsUsed: number;
};

export const PathwordStore = new Store<PathwordStoreType>({
  ...PuzzleStoreBaseDefaults,
  path: getZeroMatrix(4),
  lines: {},
  highlights: getZeroMatrix(4),
  pathLength: 0,
  pathHead: null,
  successAnimationGrid: getZeroMatrix(4),
  puzzleSize: 4,
  vowelMatrix: [],
  cluetext: [],
  solutionPath: [],
  solutionLines: {},
  almostThereIsOpen: false,
  hintLetters: [],
  enabledHints: [0, 2],
  initialEnabledHints: 2,
  hintPositions: {},
  hintsUsed: 0,
});